import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { NavTabs } from 'app/components/ui/nav-tabs'
import type { TabType } from 'app/components/ui/nav-tabs'

export type UserViewComponentProps = {
  pageTitle: string
  tabs: TabType[]
  showTabs: boolean
  userId: string
}

export const UserViewComponent = observer(function UserViewComponent({
  pageTitle,
  tabs,
  showTabs,
  userId,
}: UserViewComponentProps) {
  return (
    <PageScroll
      contentClassName="flex flex-col gap-y-8"
      header={
        <>
          <PageHeaderComponent title={pageTitle} />
          {showTabs && (
            <div className="mb-8">
              <NavTabs tabs={tabs} />
            </div>
          )}
        </>
      }
    >
      <Outlet key={userId} />
    </PageScroll>
  )
})
